export default __webpack_public_path__ + "static/media/hightlight5.ee009965.png";